export default __webpack_public_path__ + "assets/login-box-bg.de1aec0f.svg";